const PROJECT_PREFIX = 'px'

export default PROJECT_PREFIX
